import { StringSchema } from 'yup';
import * as cellPhone from '../cellPhone';
import * as telephone from '../telephone';

export default function (this: StringSchema, message = 'Insira um telefone ou celular válido') {
  return this.test('telephoneOrcellPhone', message, (value = '') => {
    const validate = value.length <= 10 ? telephone.validate : cellPhone.validate;

    return validate(value);
  });
}
